import React from "react";
import { cutText, date2str, empty, kopecks2rubStr } from "../../../common/functions";
import { DemandRate } from "../atoms/DemandRate";
import { DemandStatus } from "../atoms/DemandStatus";
import { $contractorDems } from "../logics/contractorDemands";
import { IDem } from "../logics/types";
import "../styles/DemandListItem.css";

interface IDemandListItem {
  setDbClickIdx: React.Dispatch<React.SetStateAction<number>>;
  dem: IDem;
  idx: number;
  hide?: boolean;
  showRate: boolean
}

export const DemandListItem = ({ dem, idx, setDbClickIdx, hide = false, showRate}: IDemandListItem) => {
  let disp = hide ? "none" : "block", maxHeight = empty(dem.rating) ? "151px" : "196px";
  let text = "", priceAndCount = ""
  let fullDem = $contractorDems.getState().services.find(e=>e.id === dem.contractorDemandId)
  // платная (isPayable===1) — показываем услугу/цену; бесплатная и новый тип «обращение» (0/3) — текст заявки
  if(dem.isPayable === 1) {
    text = cutText(fullDem?.name == null ? "" : fullDem.name, 32)
    if(empty(dem.qty) || empty(fullDem?.price)) priceAndCount = ""
    //@ts-ignore
    else priceAndCount = dem.qty + " усл., " + kopecks2rubStr(fullDem?.price * dem.qty)
    //priceAndCount = (dem.qty == null ? "" : dem.qty + " усл., ") + (dem.contractorDemandPrice == null ? "" : kopecks2rubStr(dem.contractorDemandPrice))
  } else {
    text = cutText(dem.initialText == null ? "" : dem.initialText, 32)
    priceAndCount = ""
  }
  
  return (
    <div onClick={() => setDbClickIdx(idx)} className="row col-12 dli_main_container cp" style={{ maxHeight: maxHeight, display: disp }}>
      <div className="row col-12 d-flex p-0 m-auto mb-0 mt-0 pb-2">
        <DemandStatus statusName={dem.statusName} add2Class="mr-auto" statusId={dem.lastStatusId} />
        <div className="ml-auto">
          <small className="mb-0 mt-1">{priceAndCount}</small>
        </div>
      </div>
      <div className="row col-12 d-flex text-left p-0 m-auto pb-2" style={{ color: "#22549D" }} >
        {dem.groupName}
      </div>
      <div className="row col-12 d-flex p-0 m-auto pb-2 ">
        {text}
      </div> 
      <div className="row col-12 d-flex p-0 m-auto" style={{ color: "#22549D" }} >
        <div className="mr-auto">Заявка № {dem.id}</div>
        <div className="ml-auto">
          {date2str(new Date(dem.createDate), ".").date}
        </div>
      </div>
      { !showRate || dem.rating === 0 ? <></>:
        <DemandRate add2class="div-dem-rate-on-list" rate={dem.rating} max={5} readonly={true} />
      } 
    </div>
  );
};
